export const getPaywallFromSubscription = (value: boolean) => {
  return !value;
}

export const getSubscriptionFromPaywall = (value: boolean) => {
  return !value;
}
